import React, { useState } from 'react';
import Tab from './Tab';

const Tablist = ({
  tabs,
  activeTab,
  clickHandler,
  idSuffix,
  tabbable = true,
}) => {
  // Keyboard navigation
  const [tabIndex, setTabIndex] = useState(0); // Counter to set the focused tab

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowRight') {
      // Increase the counter by 1
      setTabIndex(tabIndex + 1);
      // If we're at the end, go to the start
      if (tabIndex >= tabs.length - 1) {
        setTabIndex(0);
      }
    }
    if (e.key === 'ArrowLeft') {
      // Decrease the counter by 1
      setTabIndex(tabIndex - 1);
      // If we're at the start, move to the end
      if (tabIndex === 0) {
        setTabIndex(tabs.length - 1);
      }
    }
  };

  return (
    <div className={`tabList`} role="tablist">
      {tabs.map(({ tabTitle, tabId, tabpanelId }, index) => (
        <Tab
          key={index}
          tabTitle={tabTitle}
          tabId={
            idSuffix
              ? `${tabId}${
                  idSuffix.charAt(0).toUpperCase() + idSuffix.slice(1) // make the id camelCase
                }`
              : tabId
          }
          // tabId={tabId}
          // tabpanelId={tabpanelId}
          tabpanelId={
            idSuffix
              ? `${tabpanelId}${
                  idSuffix.charAt(0).toUpperCase() + idSuffix.slice(1) // make the id camelCase
                }`
              : tabpanelId
          }
          isActive={
            activeTab === tabId && tabbable // Make the tab active
          }
          clickHandler={clickHandler}
          keyDownHandler={(e) => {
            handleKeyDown(e);
          }}
          isFocused={tabIndex === index} // Compare the counter to this tab
        />
      ))}
    </div>
  );
};

export default Tablist;
